import { render, staticRenderFns } from "./ProfileMenu.vue?vue&type=template&id=122ec8a8&scoped=true"
import script from "./ProfileMenu.vue?vue&type=script&lang=js"
export * from "./ProfileMenu.vue?vue&type=script&lang=js"
import style0 from "./ProfileMenu.vue?vue&type=style&index=0&id=122ec8a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122ec8a8",
  null
  
)

export default component.exports